import { createFileRoute, redirect } from '@tanstack/react-router';

/** Moved into the Contacts hub as the "Custom fields" tab. Redirect keeps old
 *  links and bookmarks working. */
export const Route = createFileRoute('/vendor/custom-fields')({
  beforeLoad: () => {
    throw redirect({ to: '/vendor/contacts', search: { tab: 'custom-fields' } });
  },
});
